"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSupportedLocales;

var _config = require("../../config");

function getSupportedLocales() {
  return _config.SUPPORTED_LOCALES;
}